import React, { useState } from "react";
import { addAdventureLog } from "../utils/addAdventureLog";
import { db } from "../firebase";
import {
  collection,
  doc,
  deleteDoc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";

const WorldContextPanel = ({
  currentLocation,
  setCurrentLocation,
  currentEvent,
  setCurrentEvent,
  adventureLogs,
  setAdventureLogs,
}) => {
  const [newLog, setNewLog] = useState({
    sessionTitle: "",
    date: "",
    summary: "",
    tags: "",
  });

  const [editingLogId, setEditingLogId] = useState(null);
  const [editLog, setEditLog] = useState({
    sessionTitle: "",
    date: "",
    summary: "",
    tags: "",
  });

  const locationOptions = [
    "Forest",
    "Ruins",
    "Desert",
    "Tundra",
    "Mountains",
    "Deep Sea",
    "Sky Islands",
    "Volcano",
    "Shadow Realm",
    "Other",
  ];

  const addLogEntry = async () => {
    if (!newLog.sessionTitle || !newLog.summary) return;
    const newEntry = {
      ...newLog,
      tags: newLog.tags.split(",").map((tag) => tag.trim().toLowerCase()),
      createdAt: serverTimestamp(),
    };
    await addAdventureLog(newEntry);
    setNewLog({ sessionTitle: "", date: "", summary: "", tags: "" });
  };

  const startEditingLog = (log) => {
    setEditingLogId(log.id);
    setEditLog({
      sessionTitle: log.sessionTitle,
      date: log.date,
      summary: log.summary,
      tags: log.tags.join(", "),
    });
  };

  const saveEditingLog = async (id) => {
    const docRef = doc(db, "adventureLogs", id);
    await updateDoc(docRef, {
      sessionTitle: editLog.sessionTitle,
      date: editLog.date,
      summary: editLog.summary,
      tags: editLog.tags.split(",").map((tag) => tag.trim().toLowerCase()),
      updatedAt: serverTimestamp(),
    });
    console.log("✅ Adventure log updated!");
    setEditingLogId(null);
    setEditLog({ sessionTitle: "", date: "", summary: "", tags: "" });
  };

  const deleteLogEntry = async (id) => {
    if (window.confirm("Are you sure you want to delete this adventure log?")) {
      await deleteDoc(doc(db, "adventureLogs", id));
      console.log("🗑️ Adventure log deleted!");
      if (editingLogId === id) {
        setEditingLogId(null);
        setEditLog({ sessionTitle: "", date: "", summary: "", tags: "" });
      }
    }
  };

  return (
    <div
      style={{
        padding: "1rem",
        background: "#f0f0f0",
        borderRadius: "8px",
        marginBottom: "1rem",
      }}
    >
      <h3>🌍 World Context</h3>

      <div style={{ marginBottom: "1rem" }}>
        <label>📍 Current Location:</label>
        <br />
        <select
          value={currentLocation}
          onChange={(e) => setCurrentLocation(e.target.value)}
          style={{ width: "100%", padding: "8px", marginTop: "4px" }}
        >
          <option value="">Select a location</option>
          {locationOptions.map((loc, i) => (
            <option key={i} value={loc}>
              {loc}
            </option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <label>🕊️ Current Event:</label>
        <br />
        <textarea
          value={currentEvent}
          onChange={(e) => setCurrentEvent(e.target.value)}
          placeholder="Brief description of what's happening now"
          style={{ width: "100%", padding: "8px", marginTop: "4px" }}
        />
      </div>

      <h4>📜 Adventure Log</h4>

      {adventureLogs.length > 0 &&
        adventureLogs.map((log) => (
          <div
            key={log.id}
            style={{
              background: "white",
              padding: "8px",
              borderRadius: "6px",
              marginBottom: "8px",
            }}
          >
            {editingLogId === log.id ? (
              <>
                <input
                  type="text"
                  value={editLog.sessionTitle}
                  onChange={(e) =>
                    setEditLog({ ...editLog, sessionTitle: e.target.value })
                  }
                  placeholder="Session Title"
                  style={{ width: "100%", marginBottom: "4px" }}
                />
                <input
                  type="date"
                  value={editLog.date}
                  onChange={(e) =>
                    setEditLog({ ...editLog, date: e.target.value })
                  }
                  style={{ width: "100%", marginBottom: "4px" }}
                />
                <textarea
                  value={editLog.summary}
                  onChange={(e) =>
                    setEditLog({ ...editLog, summary: e.target.value })
                  }
                  placeholder="Summary"
                  style={{ width: "100%", marginBottom: "4px" }}
                />
                <input
                  type="text"
                  value={editLog.tags}
                  onChange={(e) =>
                    setEditLog({ ...editLog, tags: e.target.value })
                  }
                  placeholder="Tags (comma separated)"
                  style={{ width: "100%", marginBottom: "4px" }}
                />
                <button
                  onClick={() => saveEditingLog(log.id)}
                  style={{
                    background: "green",
                    color: "white",
                    marginRight: "8px",
                  }}
                >
                  Save
                </button>
                <button
                  onClick={() => setEditingLogId(null)}
                  style={{ background: "gray", color: "white" }}
                >
                  Cancel
                </button>
              </>
            ) : (
              <>
                <strong>{log.sessionTitle}</strong> ({log.date})<br />
                <em>{log.summary}</em>
                <br />
                <small>Tags: {log.tags.join(", ")}</small>
                <br />
                <button
                  onClick={() => startEditingLog(log)}
                  style={{
                    marginTop: "4px",
                    background: "blue",
                    color: "white",
                    marginRight: "6px",
                  }}
                >
                  Edit
                </button>
                <button
                  onClick={() => deleteLogEntry(log.id)}
                  style={{
                    marginTop: "4px",
                    background: "red",
                    color: "white",
                  }}
                >
                  Delete
                </button>
              </>
            )}
          </div>
        ))}

      <h5>Add New Adventure Log</h5>
      <input
        type="text"
        placeholder="Session Title"
        value={newLog.sessionTitle}
        onChange={(e) =>
          setNewLog((prev) => ({ ...prev, sessionTitle: e.target.value }))
        }
        style={{ width: "100%", marginBottom: "6px" }}
      />
      <input
        type="date"
        value={newLog.date}
        onChange={(e) =>
          setNewLog((prev) => ({ ...prev, date: e.target.value }))
        }
        style={{ width: "100%", marginBottom: "6px" }}
      />
      <textarea
        placeholder="Summary of session"
        value={newLog.summary}
        onChange={(e) =>
          setNewLog((prev) => ({ ...prev, summary: e.target.value }))
        }
        style={{ width: "100%", marginBottom: "6px" }}
      />
      <input
        type="text"
        placeholder="Tags (comma separated)"
        value={newLog.tags}
        onChange={(e) =>
          setNewLog((prev) => ({ ...prev, tags: e.target.value }))
        }
        style={{ width: "100%", marginBottom: "6px" }}
      />

      <button
        onClick={addLogEntry}
        style={{
          background: "green",
          color: "white",
          padding: "8px 12px",
          border: "none",
          borderRadius: "4px",
        }}
      >
        ➕ Add Log
      </button>
    </div>
  );
};

export default WorldContextPanel;
